import styled from "styled-components";

export const StyledResetPassword = styled.div<{
  isSuccess?: boolean;
  isError?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100% - var(--headerHeight));
  width: 100%;
  background-color: #f9fbfd;
  background-image: url(/static/media/register-bg.7a0b87d1.jpg);
  background-size: 100% 13.375rem;
  background-repeat: no-repeat;
  background-position: bottom;
  background-origin: border-box;
  position: relative;

  .reset__title {
    font-family: ${({ theme }) => theme.fonts.archivo};
    font-weight: 600;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.neutral[700]};
    text-align: center;
    margin: 0 auto;
  }

  .reset__subtitle {
    font-family: ${({ theme }) => theme.fonts.archivo};
    font-size: 1rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral[600]};
    margin: 1.25rem 0;
    max-width: 50ch;
  }

  .reset__inner {
    width: 440px;
  }

  .ui-button {
    margin: 1rem auto 0 auto;
    width: 50%;
  }

  .reset__password__state {
    margin: 1rem auto 0 auto;
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.archivo};
    font-size: 1.15rem;
    text-align: center;
    color: ${({ theme, isSuccess }) =>
      isSuccess ? theme.colors.success[200] : theme.colors.error[200]};
  }

  .reset__go-back {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 40px;
    left: 40px;
    font-family: ${({ theme }) => theme.fonts.archivo};
    font-size: 1rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral[600]};
    transition: all 0.3s ease-in-out;
    font-weight: 600;
  }

  .reset__go-back:hover {
    color: ${({ theme }) => theme.colors.neutral[700]};
  }

  .ui-field:first-of-type {
    margin-bottom: 1rem;
  }

  .ui-goback {
    position: absolute;
    bottom: 40px;
    left: 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: grid;
    grid-template-rows: minmax(auto, 450px) min-content;
    row-gap: 1rem;
    align-items: unset;
    padding: var(--sectionPadding);
    width: 100%;

    .reset__inner {
      width: 100%;
    }

    .reset__title {
      font-size: ${({ theme }) => theme.fontSize[25]};
      margin: 0;
      text-align: left;
    }

    .reset__subtitle {
      font-size: ${({ theme }) => theme.fontSize[16]};
      text-align: left;
      margin: ${({ theme }) => theme.spacing[16]} 0;
    }

    .ui-input {
      height: 45px;
    }

    label {
      font-size: ${({ theme }) => theme.fontSize[14]};
    }

    .ui-input__eye {
      width: 20px;
    }

    .ui-button {
      width: 100%;
      height: 45px;
    }

    .ui-goback {
      position: unset;
      text-align: center;
      justify-content: center;
    }

    .reset__inner {
      display: flex;
      flex-direction: column;
      flex: 1;

      form {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    .reset__state {
      display: none;
    }

    .reset__state--mobile {
      display: flex;
    }
  }
`;
